import MayaMorning from "../Charts/PanaCharts/MayaMorning";
import INDRADAY from "../Charts/PanaCharts/INDRADAY";
import IndraMorning from "../Charts/PanaCharts/IndraMorning";
import INDRANIGHT from "../Charts/PanaCharts/INDRANIGHT";
import MAYADAY from "../Charts/PanaCharts/MAYADAY";
import MAYANIGHT from "../Charts/PanaCharts/MAYANIGHT";
import DHARMDAY from "../Charts/PanaCharts/DHARMDAY";
import DHARMMORNING from "../Charts/PanaCharts/DHARMMORNING";
import DHARMNIGHT from "../Charts/PanaCharts/DHARMNIGHT";
import YUGDAY from "../Charts/PanaCharts/YUGDAY";
import YUGMORNING from "../Charts/PanaCharts/YUGMORNING";
import YUGNIGHT from "../Charts/PanaCharts/YUGNIGHT";
import LAKSHDAY from "../Charts/PanaCharts/LAKSHDAY";
import LAKSHMORNING from "../Charts/PanaCharts/LAKSHMORNING";
import LAKSHNIGHT from "../Charts/PanaCharts/LAKSHNIGHT";
import LAXMIDAY from "../Charts/PanaCharts/LAXMIDAY";
import LAXMIMORNING from "../Charts/PanaCharts/LAXMIMORNING";
import LAXMINIGHT from "../Charts/PanaCharts/LAXMINIGHT";
import SANDHYADAY from "../Charts/PanaCharts/SANDHYADAY";
import SANDHYAMORNING from "../Charts/PanaCharts/SANDHYAMORNING";
import SANDHYANIGHT from "../Charts/PanaCharts/SANDHYANIGHT";
import VEDADAY from "../Charts/PanaCharts/VEDADAY";
import VEDANIGHT from "../Charts/PanaCharts/VEDANIGHT";


const normalize = (name) =>
  name?.replace(/\s+/g, "").toUpperCase();

export const PANA_CHART_COMPONENTS = {
  // Original Charts
  [normalize("MAYA MORNING")]: MayaMorning,

  [normalize("INDRAMORNING")]: IndraMorning,
  [normalize("INDRADAY")]: INDRADAY,
  [normalize("INDRANIGHT")]: INDRANIGHT,

  [normalize("MAYADAY")]: MAYADAY,
  [normalize("MAYANIGHT")]: MAYANIGHT,

  [normalize("DHARMMORNING")]: DHARMMORNING,
  [normalize("DHARMDAY")]: DHARMDAY,
  [normalize("DHARMNIGHT")]: DHARMNIGHT,

  [normalize("YUGMORNING")]: YUGMORNING,
  [normalize("YUGDAY")]: YUGDAY,
  [normalize("YUGNIGHT")]: YUGNIGHT,

  [normalize("VEDADAY")]: VEDADAY,
  [normalize("VEDANIGHT")]: VEDANIGHT,

  [normalize("LAKSHMORNING")]: LAKSHMORNING,
  [normalize("LAKSHDAY")]: LAKSHDAY,
  [normalize("LAKSHNIGHT")]: LAKSHNIGHT,

  [normalize("LAXMIMORNING")]: LAXMIMORNING,
  [normalize("LAXMIDAY")]: LAXMIDAY,
  [normalize("LAXMINIGHT")]: LAXMINIGHT,

  [normalize("SANDHYAMORNING")]: SANDHYAMORNING,
  [normalize("SANDHYADAY")]: SANDHYADAY,
  [normalize("SANDHYANIGHT")]: SANDHYANIGHT,

  // ==========================
  // Alias Mapping
  // ==========================

  [normalize("SUMATIMORNING")]: LAXMIDAY,
  [normalize("GEETAMORNING")]: LAKSHNIGHT,
  [normalize("VIDYAMORNING")]: IndraMorning,

  [normalize("GEETADAY")]: SANDHYAMORNING,
  [normalize("VIDYADAY")]: SANDHYANIGHT,
  [normalize("SUMATIDAY")]: LAXMIDAY,

  [normalize("RAMAMORNING")]: SANDHYAMORNING,
  [normalize("VIDYANIGHT")]: SANDHYAMORNING,

  [normalize("SHRIDAY")]: LAXMIDAY,
  [normalize("RADHADAY")]: LAXMIDAY,
  [normalize("RAMADAY")]: LAXMIDAY,

  [normalize("RAMANIGHT")]: LAXMINIGHT,
  [normalize("SHRINIGHT")]: LAXMINIGHT,
  [normalize("RADHANIGHT")]: LAXMINIGHT,

  [normalize("SUMATINIGHT")]: LAKSHNIGHT,
  [normalize("GEETANIGHT")]: SANDHYANIGHT,
};